import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";

import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import IndentsList from "@/pages/IndentsList";
import IndentNew from "@/pages/IndentNew";
import IndentDetail from "@/pages/IndentDetail";
import POsList from "@/pages/POsList";
import PODetail from "@/pages/PODetail";
import GRNsList from "@/pages/GRNsList";
import GRNDetail from "@/pages/GRNDetail";
import InvoicesList from "@/pages/InvoicesList";
import PVsList from "@/pages/PVsList";
import UsersList from "@/pages/UsersList";
import Masters from "@/pages/Masters";
import Settings from "@/pages/Settings";
import AuditLog from "@/pages/AuditLog";
import TallySync from "@/pages/TallySync";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function ModuleGate({ mod, children }) {
  const { moduleHidden } = useAuth();
  if (moduleHidden(mod)) return <Navigate to="/" replace />;
  return children;
}

function AdminGate({ children }) {
  const { hasRole } = useAuth();
  if (!hasRole("Administrator")) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Protected><Layout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="indents" element={<IndentsList />} />
            <Route path="indents/new" element={<IndentNew />} />
            <Route path="indents/:id" element={<IndentDetail />} />
            <Route path="pos" element={<POsList />} />
            <Route path="pos/:id" element={<PODetail />} />
            <Route path="grns" element={<GRNsList />} />
            <Route path="grns/:id" element={<GRNDetail />} />
            <Route path="invoices" element={<ModuleGate mod="invoices"><InvoicesList /></ModuleGate>} />
            <Route path="pvs" element={<ModuleGate mod="pvs"><PVsList /></ModuleGate>} />
            <Route path="users" element={<AdminGate><UsersList /></AdminGate>} />
            <Route path="masters" element={<Masters />} />
            <Route path="settings/visibility" element={<AdminGate><Settings /></AdminGate>} />
            <Route path="audit" element={<AdminGate><AuditLog /></AdminGate>} />
            <Route path="tally" element={<AdminGate><TallySync /></AdminGate>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
